import styled from 'styled-components';

import { Box } from '@/shared/ui/box';

export const SelectWrapper = styled(Box)`
	width: 100%;
`;
